<template>
  <el-dialog
    :visible.sync="visible"
    :width="width"

    :before-close="handleClose"
  >
    <div slot="title">
      <span>导出列表</span>
      <el-tooltip class="item" placement="right-start">
        <ol slot="content">
          <li>导出的数据在线保存一个月，支持重复下载</li>
          <li>导出的数据超出一个月后，建议重新点击【导出数据】选择对应的数据进行导出</li>
        </ol>
        <i class="el-icon-info"></i>
      </el-tooltip>
    </div>

    <!-- 列表 -->
    <QS-common-table
      :data="tableData"
      :columns="columns"
      :pagination="paginationData"
      :maxHeight="248"
      @change="paginationChange"
    >
    </QS-common-table>

  </el-dialog>
</template>

<script>
import config from '../config/detailList/exportListDialog'
import { asyncExportList } from '@/api/domain/orders'
import * as exportApi from '@/api/export'
import Mixin from '../mixins'

const mixin = Mixin({
  getListFn: asyncExportList,
  searchData: {
    taskType: 1, // 任务类型
  },
  exportTemplate: 'DownloadFile',
})

export default {
  mixins: [mixin],
  components: {
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '824px',
    },
    filename: {
      type: String,
      default: '逾期明细表',
    },
    // eslint-disable-next-line vue/no-unused-properties
    taskType: {
      type: [Number, String],
      default: 1,
    },
  },
  watch: {
    dialogVisible(val) {
      this.visible = val
    },
  },
  data() {
    const {
      columns,
    } = config.call(this, this.filename)
    return {
      columns,
      visible: this.dialogVisible,
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    // 同步导出Excel
    // eslint-disable-next-line vue/no-unused-properties
    exportHandle(row) {
      if (row.taskStatus === 1) {
        this.$message.error('进行中的任务不能下载')
        return
      }
      if (this.oLoading.exportByColumn) return false
      this.oLoading.exportByColumn = true
      const exportTemplate = this.exportTemplate.substr(0, 1).toUpperCase() + this.exportTemplate.substr(1)
      exportApi[`export${exportTemplate}`]({
        taskId: row.taskId,
      }).then((data) => {
        if (data) {
          const url = window.URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          )
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', this.filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }).finally(() => {
        this.oLoading.exportByColumn = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
